import React, { useMemo } from 'react';
import { number, bool } from 'prop-types';
import Skeleton from 'react-loading-skeleton';

const ListingLoader = ({ count = 3, perex = true, button = true }) => {
    const skeletonItems = useMemo(() => {
        const items = [];

        if (!count) {
            return items;
        }

        for (let i = 0; i < count; i += 1) {
            items.push(
                <div className="col-md-4" key={i}>
                    <Skeleton
                        className="skeleton-rect"
                        height={150}
                        style={{
                            marginBottom: 15
                        }}
                    />
                    <Skeleton height={18} width="90%" />
                    {perex && (
                        <React.Fragment>
                            <Skeleton
                                height={10}
                                style={{
                                    marginBottom: 8,
                                    marginTop: 15
                                }}
                            />
                            <Skeleton height={10} width="80%" />
                        </React.Fragment>
                    )}
                    {button && (
                        <Skeleton
                            height={10}
                            width={80}
                            style={{
                                marginTop: 30
                            }}
                        />
                    )}
                </div>
            );
        }

        return items;
    }, []);

    return (
        <div className="grid grid--cards grid--cards--large-v-gutter">
            {skeletonItems.map(item => item)}
        </div>
    );
};

ListingLoader.propTypes = {
    button: bool,
    count: number,
    perex: bool
};

export default ListingLoader;
